import { render } from "./UpdateSchool.vue?vue&type=template&id=f8b4b3ac"
import script from "./UpdateSchool.vue?vue&type=script&lang=js"
export * from "./UpdateSchool.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./UpdateSchool.vue?vue&type=style&index=0&id=f8b4b3ac&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__